import { labFragment } from 'apollo/fragments/lab';
import { gql } from 'graphql.macro';

export const labsForAdminTemplate = gql`
    query labsForAdmin(
        $filters: LabFilters!
        $limit: Int!
        $offset: Int!
        $orderBy: String
        $orderDirection: OrderDirection
    ) {
        labsForAdmin(
            filters: $filters
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            ...labFields
            defaultMaterialPriceListId
            crediFlow {
                partyID
            }
        }
    }
    ${labFragment}
`;
